export default "__VITE_ASSET__BT5yyArB__"